import { render } from "./CoachDetail.vue?vue&type=template&id=faa1186a"
import script from "./CoachDetail.vue?vue&type=script&lang=js"
export * from "./CoachDetail.vue?vue&type=script&lang=js"
script.render = render

export default script